"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventOverviewReportPageActions;
(function (EventOverviewReportPageActions) {
    EventOverviewReportPageActions["DataLoaded"] = "DataLoaded";
    EventOverviewReportPageActions["LoadingNextReport"] = "LoadingNextReport";
})(EventOverviewReportPageActions || (EventOverviewReportPageActions = {}));
exports.default = EventOverviewReportPageActions;
